import React, { Fragment, useEffect, useRef, useState } from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import { Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Button } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import withReducer from "../../../../store/withReducer";
import {
    getOrderSettings,
    setSettings,
    showPendingReturnRequestList,
    storeReturnRequest,
    resendInvoiceReturnFeeReturnRequest,
    cancelReturnRequest
} from "../../store/orderSlice";
import { useHistory, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import orderReducer from "../../store";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { jqx } from "./../../../../custom_modules/jqx/jqwidgets-react-tsx/jqxgrid";
import * as ReactDOMServer from "react-dom/server";
import { toast } from "react-toastify";
import { mapOrderReturnResponseToTable } from "../../../../utils/mapper";
import JqxTable from "../../../../share-components/table/JqxTable";
import ButtonLoader from "../../../../share-components/ui/buttonLoader";
import * as SweetAlert from "sweetalert2";
import PreLoader from "../../../../share-components/ui/preLoader";
import PendingReturnJqx from "./content/pendingReturnJqx";
import { formatAsPrice } from "../../../../utils/common";

import TrackingForm from "./content/TrackingForm";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

let gridRef
const EditPendingReturn = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    let history = useHistory();
    const orderState = useSelector(({ order }) => order.order);
    const [loading, isSetLoading] = useState(true);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [declinedButtonDisabled, setDeclinedButtonDisabled] = useState(false);
    const [resendButtonDisabled, setResendButtonDisabled] = useState(false);
    const [openTrackingDetails, setOpenTrackingDetails] = useState(false);
    const [isAllCanDeclined, setIsAllCanDeclined] = useState(false)
    const authData = useSelector(({ authReducer }) => authReducer);

    const dataMenu = [
        {
            type: 1,
            text: 'Pending Return Requests',
            link: '/order/pending-return-requests'
        },
        {
            type: 0,
            text: "Edit Request"
        }
    ];

    useEffect(()=>{

        if(orderState.pendingReturnData.lists && orderState.pendingReturnData.lists.length > 0 && orderState.pendingReturnData.customOrder && orderState.pendingReturnData.customOrder !== null){
            const canDecline = orderState.pendingReturnData.lists.every(item => item.lable_type == 2 && (orderState.pendingReturnData.customOrder && orderState.pendingReturnData.customOrder.financial_status != 'paid' && orderState.pendingReturnData.customOrder.financial_status != 'partially_refunded' && orderState.pendingReturnData.customOrder.financial_status != 'refunded'));
            setIsAllCanDeclined(canDecline);

            // console.log("Data is coming", orderState.pendingReturnData.lists)
        }

    },[orderState])
    
    const handleCellValueChange = () => {
        var isOT = false;
        gridRef.getselectedrowindexes().forEach(i => {
            var isGoddiva = gridRef.getcellvalue(i, 'is_goddiva');
            var isDecline = gridRef.getcellvalue(i, 'isDecline') ? gridRef.getcellvalue(i, 'isDecline') : false;
            if (!isOT) {
                isOT = !isGoddiva && isDecline
            }
        });
        setOpenTrackingDetails(isOT);
    }

    const defaultValuesTracking = {
        deliver_partner: '',
        tracking_id: '',
        tracking_url: ''
    };
    const urlValidation = /^(https?:\/\/)/;
    const schemaTracking = yup.object().shape({
        tracking_id: yup.string().required('Tracking ID is required field').typeError('Tracking ID is required field'),
        tracking_url: yup.string().matches(urlValidation, "Entered URL is invalid").required('Tracking URL is required field').typeError('Tracking URL is required field'),
        deliver_partner: yup.object().required('Deliver Partner is required field').typeError('Deliver Partner is required field'),
    });

    const { handleSubmit: handleSubmitTracking, formState: formStateTracking, reset: resetTracking, register: registerTracking, setValue: setValues, getValues: getValuesTracking, trigger: triggers } = useForm({
        mode: 'onChange',
        defaultValues: defaultValuesTracking,
        resolver: yupResolver(schemaTracking)
    });

    const { errors: errorsTracking } = formStateTracking;

    useEffect(() => {
        dispatch(getOrderSettings()).then(res => {
            if (!res.error) {
                const results = {
                    settings: res.payload,
                    id: null
                }
                dispatch(setSettings(res.payload));
            }
        });
    }, [dispatch]);

    useEffect(() => {
        const requestParmas = {
            params: {
                seller: authData.defaultSeller?.value
            },
            id: id
        }
        dispatch(showPendingReturnRequestList(requestParmas)).then(res => {
            if (!res.error) {
                isSetLoading(false);
            }
        });
    }, [dispatch, authData.defaultSeller]);


    const submitData = async (type) => {
        let foundErrors = 0;
        let items = [];

        if (gridRef) {
            const gridData = gridRef.getdatainformation();
            if ((gridRef.getselectedrowindexes()).length < 1) {
                toast.error("must select at least a order ", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
            else if (gridRef.getcellvalue(0, 'isRestock') && type === 1) {
                toast.error("You can not declined item when you restock ", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                for (let i = 0; i < gridData.rowscount; i++) {
                    gridRef.getselectedrowindexes().forEach(element => {
                        if (element === i) {
                            if (gridRef.getcellvalue(i, 'chooseReturnQuantity') === undefined || gridRef.getcellvalue(i, 'chooseReturnQuantity') === "") {
                                foundErrors++;
                            }
                            items.push({
                                id: gridRef.getcellvalue(i, 'id'),
                                order_line_item_id: gridRef.getcellvalue(i, 'orderLineItemID'),
                                line_item_id: gridRef.getcellvalue(i, 'lineItemID'),
                                is_goddiva: gridRef.getcellvalue(i, 'is_goddiva'),
                                reason: gridRef.getcellvalue(i, 'reasonID'),
                                total: gridRef.getcellvalue(i, 'totalReturn'),
                                restock: gridRef.getcellvalue(i, 'isRestock') ? gridRef.getcellvalue(i, 'isRestock') : false,
                                customer_reason: gridRef.getcellvalue(i, 'customerReasonId'),
                                quantity: gridRef.getcellvalue(i, 'chooseReturnQuantity'),
                                is_declined: gridRef.getcellvalue(i, 'isDecline') ? gridRef.getcellvalue(i, 'isDecline') : false
                            });
                        }
                    });
                }

                if (openTrackingDetails) {
                    var isOT = await triggers();
                    if (!isOT) {
                        foundErrors++;
                    }
                }

                if (foundErrors > 0) {
                    toast.error("Please fill all required fields", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else {
                    var formData = {
                        orderID: orderState.pendingReturnData.data.order_id,
                        id: id,
                        items: items,
                        type: type
                    };

                    if (openTrackingDetails) {
                        const trackingFormData = getValuesTracking(); // get the form values
                        const trackingData = {
                            deliver_partner_name: trackingFormData.deliver_partner?.name,
                            tracking_number: trackingFormData.tracking_id,
                            tracking_url: trackingFormData.tracking_url
                        }
                        formData['tracking'] = trackingData;
                    }

                    SweetAlert.fire({
                        title: 'Are you sure want to process this return request?',
                        text: "Once confirmed, the return request will be sent to the system",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, Proceed',
                        cancelButtonText: 'No, cancel',
                        reverseButtons: true
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setButtonDisabled(true);
                            dispatch(storeReturnRequest(formData)).then(res => {
                                if (!res.error) {
                                    setButtonDisabled(false);
                                    history.push('/order/pending-return-requests');
                                }
                            });
                        }
                    });
                }
            }
        }
    };

    const getJqx = (jqx) => {
        gridRef = jqx;
    }

    const handlingResendInvoice = () => {
        setResendButtonDisabled(true);
        dispatch(resendInvoiceReturnFeeReturnRequest({ 'id': id })).then(res => {
            setResendButtonDisabled(false);
        });
    }

    const handleCancelReturnRequest = (state) => {

        SweetAlert.fire({
            title: `Are you sure want to cancel this return request?`,
            text: `Once confirmed, the return request will be cancelled`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Proceed',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                setDeclinedButtonDisabled(true);
                dispatch(cancelReturnRequest({id : id})).then(res => {
                  setDeclinedButtonDisabled(false);
                  if(!res.error){
                    history.push('/order/pending-return-requests');
                  }
                })
            }
        });
    }


    return (
        <Fragment>
            {loading ? <>
                <PreLoader></PreLoader>
            </> : <>
                <Breadcrumb title="Edit Pending Return Requests" data={dataMenu} />
                <Container fluid={true}>
                    <Row>
                        <Col sm="12">
                            <Card className="ribbon-wrapper">
                                <CardBody>
                                    <div className="ribbon ribbon-clip h6 ribbon-info">Items from Order {orderState.pendingReturnData.data ? orderState.pendingReturnData.data.order_name : ""}</div>

                                    <div className="mb-3 d-flex justify-content-end">
                                        {isAllCanDeclined && <ButtonLoader
                                            color="danger"
                                            disabled={declinedButtonDisabled}
                                            onClick={() => {handleCancelReturnRequest(orderState)}}
                                            btntext="Cancel Return Request"
                                            className="btn btn-danger" />}
                                        {!isAllCanDeclined && <ButtonLoader
                                            color="primary"
                                            disabled={buttonDisabled}
                                            onClick={() => {
                                                submitData(0)
                                            }}
                                            btntext="Save"
                                            className="btn btn-primary" />}
                                    </div>

                                    <PendingReturnJqx 
                                        getGridJqx={getJqx} 
                                        orderState={orderState} 
                                        handleCellValueChange={handleCellValueChange} />

                                    { openTrackingDetails && (
                                        <Row className="mt-5">
                                            <Col md="12">
                                                <h5 className="card-title">Tracking Details</h5>
                                                <TrackingForm
                                                    orderState={orderState}
                                                    trigger={triggers}
                                                    errors={errorsTracking}
                                                    register={registerTracking}
                                                    setValue={setValues}
                                                    getValues={getValuesTracking} />
                                            </Col>
                                        </Row>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {orderState.pendingReturnData.customOrder && (
                        <Row>
                            <Col md="6">
                                {(orderState.pendingReturnData.customOrder && orderState.pendingReturnData.customOrder.draft_order_status != 'completed') && <>
                                    <Card className="ribbon-wrapper">
                                        <CardBody>
                                            <div className="ribbon ribbon-clip h6 ribbon-dark">Return Fee for Draft Order Details - {orderState.pendingReturnData.customOrder.draft_order_name}</div>

                                            <div className="mb-3">
                                                <span className="form-label font-weight-bold">Amount : </span>
                                                <span>£{formatAsPrice(orderState.pendingReturnData.customOrder.amount)}</span>
                                            </div>

                                            <div className="mb-3">
                                                <span className="form-label font-weight-bold">Status : </span>
                                                <span>
                                                    {orderState.pendingReturnData.customOrder.draft_order_status_name}
                                                </span>
                                            </div>

                                            <div>
                                                <span className="form-label font-weight-bold">Invoice Status : </span>
                                                <span>
                                                    Sent on {(new Date(orderState.pendingReturnData.customOrder.invoice_sent_at).toLocaleDateString())}
                                                    &nbsp;at {(new Date(orderState.pendingReturnData.customOrder.invoice_sent_at).toLocaleTimeString())}
                                                </span>
                                                <Button color="primary" size="xs" type="button" className="ml-3" onClick={handlingResendInvoice} disabled={resendButtonDisabled}>
                                                    {resendButtonDisabled && <i className="fa fa-spinner fa-spin" />} Resend Invoice
                                                </Button>
                                            </div>

                                            {/* <div>
                                                <span className="form-label font-weight-bold">Invoice : </span>
                                                <a target="_blank" href={orderState.pendingReturnData.customOrder.draft_order_invoice_url}>View</a>
                                            </div> */}
                                        </CardBody>
                                    </Card>
                                </>}

                                {(orderState.pendingReturnData.customOrder && orderState.pendingReturnData.customOrder.draft_order_status == 'completed') && <>
                                    <Card className="ribbon-wrapper">
                                        <CardBody>
                                            <div className="ribbon ribbon-clip h6 ribbon-dark">Return Fee for Order Details</div>

                                            <div className="mb-3">
                                                <span className="form-label font-weight-bold">Order ID : </span>
                                                <span>{orderState.pendingReturnData.customOrder.order_name}</span>
                                            </div>

                                            <div>
                                                <span className="form-label font-weight-bold">Financial Status : </span>
                                                <span>{orderState.pendingReturnData.customOrder.financial_status_name}</span>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </>}
                            </Col>
                        </Row>
                    )}
                </Container>
            </>}
        </Fragment>
    );
}

export default withReducer([{ order: orderReducer }])(EditPendingReturn);